import {
	StyleFunctionProps,
	extendTheme,
	theme as chakraTheme,
	withDefaultColorScheme,
} from "@chakra-ui/react";

export const colors = {
	white: "#ffffff",
	toughCADOrange: "#EE7F22",
	orange: {
		50: "#FFF4E8",
		100: "#FFD9B3",
		200: "#FFBE80",
		300: "#FFA24D",
		400: "#FF8726",
		500: "#EE7F22", // 👈 MAIN BUTTON BG
		600: "#D86F1B",
		700: "#B85D15",
		800: "#944A10",
		900: "#6B350B",
	},
};

const fonts = {
	heading: "Manrope",
	body: "Manrope",
	navLink: "Open Sans Hebrew Condensed",
};

const config = {
	initialColorMode: "light",
	useSystemColorMode: false,
};

const styles = {
	global: (props: StyleFunctionProps) => ({
		"*:focus-visible": {
			outline: "3px solid #944A10",
			outlineOffset: "3px",
		},
		"main h1": { fontSize: { base: "2xl", md: "3xl" }, lineHeight: 1.25 },
		body: {
			bg: props.colorMode === "dark" ? "gray.900" : "gray.50",
		},
	}),
};

const components = {
	Card: {
		baseStyle: {
			container: {
				border: 0,
				borderRadius: "12px",
				boxShadow: "0 10px 28px rgba(25, 36, 44, 0.06)",
				minW: 0,
			},
			header: { px: { base: 4, md: 6 }, pt: 6, pb: 3 },
			body: { px: { base: 4, md: 6 }, py: 5 },
			footer: { px: { base: 4, md: 6 }, pb: 6 },
		},
	},
	Button: {
		baseStyle: { whiteSpace: "normal", height: "auto", minH: 10 },
		variants: {
			solid: (props: StyleFunctionProps) => ({
				...chakraTheme.components.Button.variants?.solid(props),
				color: props.colorScheme === "orange" ? "white" : "black",
			}),
		},
	},
	FormLabel: { baseStyle: { fontSize: "sm", mb: 2 } },
};
const theme = { colors, fonts, config, styles, components };

const customTheme = extendTheme(
	theme,
	withDefaultColorScheme({
		colorScheme: "orange",
		components: ["Button", "Badge", "Text"],
	}),
);

export default customTheme;
